import loginMock from './api/auth/mock'

const mockConfigs = [
  loginMock
]

mockConfigs.forEach(mockConfig => {
  if (mockConfig.enabled === false) {
    // console.log(`mock disabled: ${mockConfig.name}`)
    return
  }
  mockConfig.initMocks()
})

export default {}



// WEBPACK FOOTER //
// ./src/mock.js